import { COUNTRY_CODE } from '@cemex-core/cmx-api';

/**
 * Theres cases in each environments where the translation labels are not defined
 * Use this as a helper class
 */
export class Numberify {
  static defaultDecimalSeparator(country: COUNTRY_CODE): string {
    if (country === COUNTRY_CODE.COLOMBIA) {
      return ',';
    } else {
      return '.';
    }
  }

  static defaultThousandSeparator(country: COUNTRY_CODE): string {
    if (country === COUNTRY_CODE.COLOMBIA) {
      return '.';
    } else {
      return ',';
    }
  }

  static stringToNumber(stringNumber: string, decimalSeparator: string, thousandSeparator: string): number {
    if (!stringNumber) {
      return NaN;
    }
    stringNumber = stringNumber.replace(new RegExp('\\' + thousandSeparator, 'g'), '');
    stringNumber = stringNumber.replace(new RegExp('\\' + decimalSeparator, 'g'), '.');
    return parseFloat(stringNumber);
  }

  static numberToString(
    number: number,
    decimalSeparator: string,
    thousandSeparator: string,
    decimalLimit?: number,
  ): string | null {
    if (!number) {
      return null;
    }

    let stringNumber: string;
    if (decimalLimit) {
      stringNumber = number.toFixed(decimalLimit).replace('.', decimalSeparator);
    } else {
      stringNumber = number.toString().replace('.', decimalSeparator);
    }

    const parts = stringNumber.split(decimalSeparator);
    parts[0] = parts[0].toString().replace(/\B(?=(\d{3})+(?!\d))/g, thousandSeparator);
    stringNumber = parts.join(decimalSeparator);
    return stringNumber;
  }

  static round(numberToRound: number, decimals = 2) {
    const decimalPow = Math.pow(10, decimals);
    return Math.round(numberToRound * decimalPow + Number.EPSILON) / decimalPow;
  }

  static isNumberByCharCode(charCode) {
    return charCode >= 48 && charCode <= 57;
  }
}
